import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

const NotFound: React.FC = () => {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name="search" />
        Opps we have looked everywhere and could not find what you are looking
        for!
      </Header>
      <Segment.Inline>
        <Button as={Link} to="/activities">
          <Icon name="arrow left" /> Back to Activities
        </Button>
      </Segment.Inline>
    </Segment>
  );
};

export { NotFound };
